



















































































import {Vue, Component} from 'vue-property-decorator';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import {ncpPopup} from '@/utils/ncp';
import countrys from '@/const/words/country';
import {PostWarehouse, PutWarehousesByWarehouseNoRequest, PostWarehousesRequest, Address, OriginalAddress} from 'supporter';
import _ from 'underscore';
@Component({
  components: {
    CompSelectBox
  }
})
export default class DeliveryWarehouseList extends Vue {
  private warehouse: PostWarehouse | null = null;
  private countrys = countrys;
  private isEditForm = false;
  private fetchWarehouse(warehouseNo: number) {
    this.$api
      .getWarehousesByWarehouseNo({
        params: {
          warehouseNo: '' + warehouseNo
        }
      })
      .then(ret => {
        const {data} = ret;
        this.warehouse = {
          defaultReleaseWarehouse: data.defaultReleaseWarehouse,
          usesSubstitutionText: data.substitutionText ? true : false,
          address: data.substitutionText ? {countryCd: 'KR'} : data.address,
          name: data.name,
          substitutionText: data.substitutionText,
          defaultReturnWarehouse: data.defaultReturnWarehouse
        };
      });
  }
  created() {
    if (this.$route.query.hasOwnProperty('warehouseNo')) {
      this.isEditForm = true;
      this.fetchWarehouse(Number(this.$route.query.warehouseNo));
    } else {
      this.warehouse = {
        defaultReleaseWarehouse: false,
        usesSubstitutionText: false,
        name: '',
        defaultReturnWarehouse: false,
        address: {
          countryCd: 'KR',
          zipCd: undefined,
          jibunAddress: undefined,
          detailAddress: undefined,
          overseaCity: undefined,
          overseaRegion: undefined,
          overseaAddress1: undefined,
          overseaAddress2: undefined,
          address: undefined
        }
      };
    }
  }
  cancel() {
    if (confirm(this.$t('DELIVERY_GROUP_TEMPLATE_WAREHOUSE_ADD_CONFIRM1').toString())) {
      window.close();
    }
  }
  mounted() {}
  private save() {
    if (this.isValid()) {
      const warehouse = this.warehouse as PostWarehouse;
      if (warehouse.usesSubstitutionText) {
        delete warehouse.address;
      }
      if (this.isEditForm) {
        const request: PutWarehousesByWarehouseNoRequest = {
          params: {
            warehouseNo: Number(this.$route.query.warehouseNo)
          },
          data: warehouse
        };

        this.$api.putWarehousesByWarehouseNo(request).then(() => {
          alert(this.$t('DELIVERY_GROUP_TEMPLATE_WAREHOUSE_ADD_ALERT1'));
          window.opener.location.reload();
          window.close();
        });
      } else {
        const request: PostWarehousesRequest = {
          data: warehouse
        };
        this.$api.postWarehouses(request).then((ret: any) => {
          const warehouse = ret.data;
          alert(this.$t('DELIVERY_GROUP_TEMPLATE_WAREHOUSE_ADD_ALERT2'));
          const releaseWarehouse = window.opener.$('#selectReleaseWarehouse');
          const returnWarehouse = window.opener.$('#selectReturnWarehouse');
          if (releaseWarehouse.length) {
            _.templateSettings = {
              interpolate: /\{\{(.+?)\}\}/g
            };
            const releaseWarehouseHtmlGenerator = _.template('<option warehouseName="{{name}}" value="{{warehouseNo}}">{{summary}}</option>');
            const returnWarehouseHtmlGenerator = _.template('<option warehouseName="{{name}}" value="{{warehouseNo}}">{{summary}}</option>');
            const releaseWarehouseOptionRow = releaseWarehouseHtmlGenerator(warehouse);
            const returnWarehouseOptionRow = returnWarehouseHtmlGenerator(warehouse);
            releaseWarehouse.append(releaseWarehouseOptionRow);
            returnWarehouse.append(returnWarehouseOptionRow);
            // if (typeof window.opener.ncp.deliveryCondition !== 'undefined') {
            //   window.opener.ncp.deliveryCondition.warehouses.push(warehouse);
            // }
            window.close();
          } else {
            window.opener.location.reload();
            window.close();
          }
        });
      }
    }
  }
  private isValid() {
    const warehouse = this.warehouse as PostWarehouse;
    if (!warehouse.name) {
      alert(this.$t('DELIVERY_GROUP_TEMPLATE_WAREHOUSE_ADD_ALERT3'));
      (this.$refs.warehouseName as any).focus();
      return false;
    }
    const address = warehouse.address as Address;
    if (warehouse.usesSubstitutionText) {
      if (!warehouse.substitutionText) {
        alert(this.$t('DELIVERY_GROUP_TEMPLATE_WAREHOUSE_ADD_ALERT4'));
        (this.$refs.substitution as any).focus();
        return false;
      }
    } else if (address.countryCd === 'KR') {
      if (!address.zipCd || !address.address || !address.detailAddress) {
        alert(this.$t('DELIVERY_GROUP_TEMPLATE_WAREHOUSE_ADD_ALERT5'));
        (this.$refs.detailAddress as any).focus();
        return false;
      }
    } else {
      if (!address.overseaAddress1) {
        alert(this.$t('DELIVERY_GROUP_TEMPLATE_WAREHOUSE_ADD_ALERT6'));
        (this.$refs.overseaAddress1 as any).focus();
        return false;
      }
      if (!address.overseaAddress2) {
        alert(this.$t('DELIVERY_GROUP_TEMPLATE_WAREHOUSE_ADD_ALERT7'));
        (this.$refs.overseaAddress2 as any).focus();
        return false;
      }
      if (!address.overseaCity) {
        alert(this.$t('DELIVERY_GROUP_TEMPLATE_WAREHOUSE_ADD_ALERT8'));
        (this.$refs.overseaCity as any).focus();
        return false;
      }
      if (!address.overseaRegion) {
        alert(this.$t('DELIVERY_GROUP_TEMPLATE_WAREHOUSE_ADD_ALERT9'));
        (this.$refs.overseaRegion as any).focus();
        return false;
      }
      if (!address.zipCd) {
        alert(this.$t('DELIVERY_GROUP_TEMPLATE_WAREHOUSE_ADD_ALERT0'));
        (this.$refs.overseaZipCd as any).focus();
        return false;
      }
    }
    return true;
  }
  setAddress(address: OriginalAddress) {
    ((this.warehouse as PostWarehouse).address as Address).zipCd = address.zipCode;
    ((this.warehouse as PostWarehouse).address as Address).address = address.roadAddress;
    ((this.warehouse as PostWarehouse).address as Address).detailAddress = address.roadAddressExtra;
    this.$forceUpdate();
  }
  callback(address: OriginalAddress) {
    (window as any).addressCallback = undefined;
    this.setAddress(address);
  }
  goSelectAddress() {
    (window as any).addressCallback = this.callback;
    ncpPopup('/address/search/popup?dataCallback=addressCallback', this.$t('DELIVERY_GROUP_TEMPLATE_WAREHOUSE_ADD_POSTAL_CODE'), 550, 880);
  }
}
